import camelcaseKeys from "camelcase-keys"

export default class JsonUtil {
  static jsonToObject<T>(Type: { new(): T }, data: Record<string, unknown>): T {
    const obj: T = new Type()
    Object.assign(obj, camelcaseKeys(data, { deep: true }))
    return obj
  }

  static objectToJson<T>(data: T, properties: string[]): Record<string, unknown> {
    let obj = {}
    const camelToSnake = (n: string) => {
      return n.replace(/[A-Z]/g, (s: string) => '_' + s.toLowerCase())
    }
    const ents: [string, unknown][] = Object.entries(data)
    for (const [key, value] of ents) {
      const camelKey = camelToSnake(key)
      if (properties.indexOf(camelKey) >= 0) {
        obj = Object.assign(obj, { [camelKey]: value })
      }
    }
    return obj
  }
}
